/**
 * 订单管理（订单、退单记录）
 */
import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const financial = {
  /**
   * 订单记录
   */
  //POST /financial/orderCardPage orderCardPage 分页查询订单记录
  orderCardPage(params) {
    return axios.post(`${base.baseURL}financial/orderCardPage`, params)
  },
  //GET   /financial/{orderId}  查询订单记录之交易明细---ygt
  orderId(orderId) {
    return axios.get(`${base.baseURL}financial/${orderId}`)
  },
  /**
   * 
   * @param {退单记录} params 
   */
  // POST/orderRefund/chargeback 退单记录
  chargeback(params) {
    return axios.post(`${base.baseURL}orderRefund/chargeback`, params)
  },
  //GET /orderRefund/getChargebackInfo/{orderId} 退单记录点击查看详情----ygt
  getChargebackInfo(orderId) {
    return axios.get(`${base.baseURL}orderRefund/getChargebackInfo/${orderId}`)
  },
  //POST /orderRefund/loadFile 媒体数据上传
  loadFile(params) {
    return axios.post(`${base.baseURL}orderRefund/loadFile`, params)
  },
  // GET /orderRefund/passRefundApply/{orderId} 通过申请
  passRefundApply(orderId) {
    return axios.get(`${base.baseURL}orderRefund/passRefundApply/${orderId}`)
  },

   // GET /orderRefund/passRefundApply/{orderId} 通过申请
   export(params) {
    return axios.post(`${base.baseURL}financial/export`,params)
   },
  //POST /orderRefund/refundApply 申请退款
  refundApply(params) {
    return axios.post(`${base.baseURL}orderRefund/refundApply`, params)
  },
  // GET/order/applyRefund/{orderId}PC---订单记录申请退款---ygt
  applyRefund(orderId) {
    return axios.get(`${base.baseURL}order/applyRefund/${orderId}`)
  },
  //GET /orderRefund/testRefund test退款测试
  testRefund(params) {
    return axios.post(`${base.baseURL}orderRefund/testRefund`, params)
  },
  // POST/financial/settleOrder 財務結算
  settleOrder(params) {
    return axios.post(`${base.baseURL}financial/settleOrder`, params)
  },
  // GET/financial/exportsettle 导出結算金額數據
  exportsettle(params) {
    return axios.post(`${base.baseURL}financial/exportsettle`, params)
  },
}

export default financial;



// WEBPACK FOOTER //
// ./src/network/financial.js